import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, viewChild } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
@Component({
  selector: 'staff-info-report',
  templateUrl: './staff-info-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class StaffInfoReportComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly op = viewChild<Popover>('op');
  readonly op2 = viewChild<Popover>('op2');

  isEmptyAndNull(obj: any) {
    if (!obj) return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false;
  }

  toggleOverlay = (event: Event) => {
    this.op()?.toggle(event);
    this.op2()?.toggle(event);
  };
  show = (event: Event) => this.op()?.show(event);
  hide = () => this.op()?.hide();
}
